import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useUser } from 'modules/User';
import { ReactElement, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { isStandalone } from 'utils/environment';
import { NewWidget } from 'widgets/Widget.types';

import { BrandKitMenu } from '../BrandKitMenu';
import { UploadMenu } from '../ImageUploadMenu/UploadMenu';

export interface PhotoWidgetMenuProps {
  isMenuActive: boolean;
  onItemClick: (widget: NewWidget | NewWidget[]) => void;
}

export const PhotoWidgetMenuCategory = memo(
  ({ isMenuActive, onItemClick }: PhotoWidgetMenuProps): ReactElement | null => {
    const { isEducationUser } = useUser();
    const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu' });
    const showBrandTab = !isEducationUser && !isStandalone;

    return (
      <Box display={isMenuActive ? 'block' : 'none'} h='full'>
        <Tabs variant='left-menu' isLazy>
          <TabList>
            <Tab>{t('uploads')}</Tab>
            {showBrandTab && <Tab>Brand Kit</Tab>}
          </TabList>
          <TabPanels>
            <TabPanel p='0'>
              <UploadMenu onAddUploadImage={onItemClick} />
            </TabPanel>
            {showBrandTab && (
              <TabPanel>
                <BrandKitMenu onItemClick={onItemClick} />
              </TabPanel>
            )}
          </TabPanels>
        </Tabs>
      </Box>
    );
  },
);
PhotoWidgetMenuCategory.displayName = 'PhotoWidgetMenuCategory';
